







































































































































import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component, Inject, Prop, Watch,
} from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import { ProductResource, ValidationResult } from '@/api/product/';
import { ProductTypeMap } from '@/api/producttypes';
import { AccountProductTypeMap } from '@/api/accountproducttypes';
import { ProductMapping } from '@/api/productmapping';
import { QualRewardGroup } from '@/api/product/levelrewards';
import { IQualifier } from '@/api/product/levelrewards/qualifiers';
import { IReward, InterestReward } from '@/api/product/levelrewards/rewards';
import { ATM } from '@/api/atmsettings';
import EditLogicDialog from './EditLogicDialog.vue';
import EditQualificationDialog from './qualifications/EditQualificationDialog.vue';
import EditRewardDialog from './rewards/EditRewardDialog.vue';

@Component({
  computed: mapState(['fiId']),
  components: {
    EditLogicDialog,
    EditQualificationDialog,
    EditRewardDialog,
  },
})
export default class QualRewardGroupPanel extends Vue {
  @Prop() value!: QualRewardGroup;

  @Prop() productType!: string;

  @Prop() isLast!: boolean;

  @Prop() productHasInterestReward!: boolean;

  @Prop({ default: false }) isEditable!: boolean;

  @Prop()
  productTypes!: ProductTypeMap;

  @Prop()
  productMappings!: ProductMapping[];

  @Prop()
  accountProductTypes!: AccountProductTypeMap;

  @Prop()
  atmSetting!: ATM | null;

  @Inject('ProductResource')
  productResource!: ProductResource;

  workingQualRewardGroup: QualRewardGroup | null = null;

  fiId!:string;

  friendlyLogicName:any = {
    AND: 'And',
    OR: 'Or',
  }

   qualTableHeaders: DataTableHeader[] = [
     {
       text: 'Qualification', value: '', align: 'start', sortable: false, width: '40%',
     },
     {
       text: 'Setup', value: '', align: 'start', sortable: false, width: '50%',
     },
     {
       text: '', value: '', align: 'start', sortable: false, width: '10%',
     },
   ];

    rewardTableHeaders: DataTableHeader[] = [
      {
        text: 'Reward', value: '', align: 'start', sortable: false, width: '40%',
      },
      {
        text: 'Setup', value: '', align: 'start', sortable: false, width: '50%',
      },
      {
        text: '', value: '', align: 'start', sortable: false, width: '10%',
      },
    ];

    mounted() {
      this.onNewQualRewardGroup();
    }

    @Watch('value.level')
    onLevelChange() {
      this.workingQualRewardGroup!.level = this.value.level;
    }

    onNewQualRewardGroup() {
      this.workingQualRewardGroup = ProductResource.createEmptyQualRewardGroup();
      Object.assign(this.workingQualRewardGroup, this.value);
      this.workingQualRewardGroup.qualifiers.forEach((qualifier:IQualifier) => {
        this.validateQualifier(qualifier);
      });

      this.workingQualRewardGroup.rewards.forEach((reward:IReward) => {
        this.validateReward(reward);
      });
    }

    onChange() {
      this.$emit('input', this.workingQualRewardGroup);
    }

    validateQualifier(qualifier:IQualifier) {
      /* eslint-disable no-param-reassign */
      qualifier.validationErrors = null;
      /* eslint-enable no-param-reassign */

      this.productResource.validateQualifier(this.fiId, qualifier).then((result:ValidationResult) => {
        /* eslint-disable no-param-reassign */
        qualifier.validationErrors = result.failures;
        (qualifier as any).hasErrors = true;
      /* eslint-enable no-param-reassign */
      }).catch((error:any) => {
        this.showError(error);
      });
    }

    validateReward(reward:IReward) {
    /* eslint-disable no-param-reassign */
      reward.validationErrors = null;
      /* eslint-enable no-param-reassign */

      this.productResource.validateReward(this.fiId, reward).then((result:ValidationResult) => {
      /* eslint-disable no-param-reassign */
        reward.validationErrors = result.failures;
        (reward as any).hasErrors = true;
      /* eslint-enable no-param-reassign */
      }).catch((error:any) => {
        this.showError(error);
      });
    }

  getFailure = (failureType:string) : any => {
    switch (failureType) {
      case 'UNMAPPED_TRANSACTION_CLASSIFICATIONS':
        return {
          location: 'transactionclassification',
          message: 'Unmapped Transaction Classification(s)',
        };
      case 'UNMAPPED_STATEMENT_CODES':
        return {
          location: 'statementcodemappingsrules',
          message: 'Unmapped Statement Code(s)',
        };
      case 'UNCONFIGURED_ATM_SETTINGS':
        return {
          location: 'atmsettings',
          message: 'Unconfigured ATM Settings',
        };
      default:
        throw new Error(`unsupported failure type: ${failureType}`);
    }
  }

  isSaverProduct() : boolean {
    return this.productType === 'KASASA_SAVER';
  }

  isIncontrolBurnDown() : boolean {
    return this.productType === 'INCONTROL_BURN_DOWN';
  }

  isFixedQualifierProduct() : boolean {
    return this.isSaverProduct() || this.isIncontrolBurnDown();
  }

  isLevelZero() : boolean {
    return this.workingQualRewardGroup?.level === 0;
  }

  removeQualifier(index:number) {
    this.workingQualRewardGroup!.qualifiers.splice(index, 1);
    this.onChange();
  }

  removeReward(index:number) {
    this.workingQualRewardGroup!.rewards.splice(index, 1);
    this.$emit('rewardDeleted');
    this.onChange();
  }

  onNewQualification(newQual: IQualifier) {
    this.workingQualRewardGroup!.qualifiers.push(newQual);
    this.validateQualifier(newQual);
    this.onChange();
  }

  onNewReward(newReward: IReward) {
    // If the new reward is interest and we specified a non-qual apr, emit an event to ensure that level zero exists.
    /* eslint-disable no-underscore-dangle */
    if (newReward._class === InterestReward.CLASS && (newReward as InterestReward).nonQualifyingApr) {
    /* eslint-enable no-underscore-dangle */
      this.$emit('newNonQualApr', (newReward as InterestReward).nonQualifyingApr);
      /* eslint-disable no-param-reassign */
      (newReward as InterestReward).nonQualifyingApr = null;
      /* eslint-able no-param-reassign */
    }


    this.workingQualRewardGroup!.rewards.push(newReward);
    this.validateReward(newReward);
    this.onChange();
  }

  onEditQualification(editedQual: IQualifier) {
    this.validateQualifier(editedQual);
    this.onChange();
  }

  onEditReward(editedReward: IReward) {
    this.validateReward(editedReward);
    this.onChange();
  }

  onNewLogic(logic:string, autoQualifyCycles: number) {
    this.workingQualRewardGroup!.qualificationLogic = logic;
    this.workingQualRewardGroup!.autoQualifyCycles = autoQualifyCycles;
    this.onChange();
  }

  onLevelUp() {
    this.$emit('levelUp');
  }

  onLevelDown() {
    this.$emit('levelDown');
  }

  onLevelDelete() {
    this.$emit('levelDelete');
  }

  showError(error: any) {
    console.error(error);
    if (error.response && error.response.data && error.response.data.entity) {
      this.setError(error.response.data.entity);
    } else {
      this.setError('An unexpected error occurred.');
    }
  }

  setError(message: string) {
    const al = new Alert(message, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
